// extracted by mini-css-extract-plugin
export var main = "FeedbackMesage-module--main--2VX8N";
export var wrapper = "FeedbackMesage-module--wrapper--2Kb26";
export var wrapper__container = "FeedbackMesage-module--wrapper__container--2dr1q";
export var wrapper__container__iconWrap = "FeedbackMesage-module--wrapper__container__iconWrap--3hrm7";
export var wrapper__container__iconWrap__icon = "FeedbackMesage-module--wrapper__container__iconWrap__icon--lnTrg";
export var wrapper__container__text = "FeedbackMesage-module--wrapper__container__text--2P7X8";
export var wrapper__container__button = "FeedbackMesage-module--wrapper__container__button--39KlA";